angular = require('angular')

module.exports =
  angular
  .module('App.Components.Payments', [])

  .component('paymentsList', require('./list'))
  .component('paymentShow', require('./show'))
